export default "__VITE_ASSET__DQZfvFmS__"